import "./OurPhilosophy.module.css";
import Header from "@/reusable_sections/Header";
import Compass from "./sections/Compass";
import Journey from "./sections/Journey";
import Professionals from "./sections/Professionals";
import Footer from "@/reusable_sections/Footer";
export default function OurPhilosophyPage() {
  return <div>
      <Header />
      <Compass />
      <Journey />
      <Professionals />
      <Footer />
    </div>;
}